import { Icon, IconProps } from "@opendash/icons";
import styled from "styled-components";

export const Dragger: React.FC<IconProps & { isdragging: "true" | "false" }> =
  styled(Icon)<{
    isdragging: "true" | "false";
  }>`
    cursor: ${(props) => (props.isdragging === "true" ? "grabbing" : "grab")};
  `;
